<div class="p8-bdc_categories__container">
  <div class="p8-bdc_categories__title mat-display-1">{{ site.heading_pages }}</div>
  <div class="p8-bdc_categories__buttons"
       fxLayout="row wrap"
       fxLayoutAlign="center"
       fxLayoutGap="20px"
  >
    <p8-bdc-category *ngFor="let category of getMainCategories()"
                     [category]="category"
                     fxFlex="25%"
                     fxFlex.sm="33%"
                     fxFlex.xs="100%"
    ></p8-bdc-category>
  </div>
</div>

